/* eslint-disable import/no-extraneous-dependencies, @typescript-eslint/naming-convention */
import React, { useState } from 'react';
import RuleEnforcementChoice from './RuleEnforcementChoice';
import { RULE_ENFORCEMENT_BLOCK, RULE_ENFORCEMENT_GUIDANCE } from '../types';
const DICT = {
    'rules.form.enforcement_label': 'How the assistant should treat this',
    'rules.form.enforcement_guidance': 'The assistant should take this into account',
    'rules.form.enforcement_guidance_hint': 'Guidance. The assistant reads this when deciding what to do.',
    'rules.form.enforcement_block': 'The assistant must never do this',
    'rules.form.enforcement_block_hint': 'A hard block. The assistant refuses this action every time, including when it is part of a larger request.'
};
const t = (key) => { var _a; return (_a = DICT[key]) !== null && _a !== void 0 ? _a : key; };
function StatefulChoice({ initial }) {
    const [value, setValue] = useState(initial);
    return React.createElement(RuleEnforcementChoice, { value: value, onChange: setValue, t: t });
}
const meta = {
    title: 'Features/Settings/TenantKnowledgeBase/RuleEnforcementChoice',
    component: StatefulChoice,
    parameters: { layout: 'padded' }
};
export default meta;
/** Default for a new rule: guidance, enforced by prompting. */
export const Guidance = {
    args: { initial: RULE_ENFORCEMENT_GUIDANCE }
};
/** Hard block: the assistant refuses the chosen action every time. */
export const HardBlock = {
    args: { initial: RULE_ENFORCEMENT_BLOCK }
};
